import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Record } from "appworks/model/gameplay/records/record";
import { Services } from "appworks/services/services";
import { TGRShouldCelebrateWins } from "commands/tgr-should-celebrate-wins";
import { TGRMatrixComponent } from "components/tgr-matrix";
import { gamevyModel } from "gamevy/gamevy-model";
import GamevyShowWinLines from "gamevy/states/gamevy-show-win-lines";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";
import { Jurisdiction } from "slotworks/services/jurisdiction/jurisdiction-service";

export class TGRShowWinLines extends GamevyShowWinLines {

    public onEnter(): void {
        const record = gameState.getCurrentGame().getCurrentRecord();

        if (!TGRShouldCelebrateWins(record)) {
            this.complete();
        } else {
            super.onEnter();
        }
    }

    public onExit(): void {
        super.onExit();
        Components.get(TGRMatrixComponent).darkenReels(false, 100).execute();
    }

    protected getWinsToShow(record: Record): SymbolWinResult[] {

        const results = record.getResultsOfType(SymbolWinResult);

        let lineWinsBelowStake: boolean = false;
        if ([Jurisdiction.UK, Jurisdiction.Alderney].indexOf(gamevyModel.jurisdiction) > -1) {
            if (record.cashWon < Services.bet.getTotalStake()) {
                lineWinsBelowStake = true;
            }
        }

        return results.filter((result) => {
            return !lineWinsBelowStake && (result.cashWon > 0 || result.linkedResult instanceof FreespinWinResult);
        });
    }
}
